export const faqsKeys = {
  all: ['faqs'] as const,
  list: () => [...faqsKeys.all, 'list'] as const,
}
